import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { FilterDialogComponent } from '@app/pages/common/filter-dialog/filter-dialog.component';
import { ShowHideDialogComponent } from '@app/pages/common/show-hide-dialog/show-hide-dialog.component';
import { BsModalRef, BsModalService, ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';
import { TableLazyLoadEvent } from 'primeng/table';
import { catchError, EMPTY, map } from 'rxjs';

@Component({
  selector: 'app-historicalmetrics',
  templateUrl: './historicalmetrics.component.html',
  styleUrls: ['./historicalmetrics.component.scss'],
})
export class HistoricalmetricsComponent implements OnInit, OnDestroy {
  @ViewChild('modal') myModal: ModalDirective;

  constructor(
    private utils: Utils,
    private webStorage: WebStorageService,
    private appService: AppService,
    private managerService: ManagerService,
    private router: Router,
    private modalService: BsModalService,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {}
  currentMenu: any = {};
  action = '';
  innerHeight = 10;
  showTable: boolean = true;
  showCrud: boolean = false;
  showDateRange: boolean = true;
  first = 0;
  totalRecords: number = 0;
  loading: boolean;
  modalRef?: BsModalRef;
  historicalMetricList: any = [];
  localStorageName = 'HistoricalMetricsColumnDisplaySettings';
  headercount: any = { shown: 0, hidden: 0 };

  /*globalfilter*/
  findOptions: any = [
    { label: 'First Name', value: 'FirstName' },
    { label: 'Last Name', value: 'LastName' },
    { label: 'User ID', value: 'UserID' },
    { label: 'Email', value: 'Email' },
  ];

  rowOffset = 0;
  rowCount = 10;
  searchField: any = { label: '', value: '' };
  searchValue: any = '';
  filterDict: any = null;
  sortColumn = 'Date';
  sortDescend = true;
  filterOptionRequestColumn = null;
  fromDate: Date = new Date();
  toDate: Date = new Date();
  pl: any = {};

  cols: any = [
    { name: 'ID', label: 'ID' },
    { name: 'Name', label: 'Name' },
    { name: 'Group', label: 'Group', showFilter: true },
    { name: 'TotalCalls', label: 'Total Calls' },
    { name: 'CallsPerDay', label: 'Avg. Calls Per Day' },
    {
      name: 'CallDuration',
      label: 'Avg. Call Duration',
      type: 'numeric',
      format: 'duration',
    },
    { name: 'CallsToday', label: 'Calls Today' },
    { name: 'LastCall', label: 'Last Call', type: 'date' },
    { name: 'TotalAudits', label: 'Total Audits' },
    { name: 'LastAudit', label: 'Last Audit', type: 'date' },
  ];
  loadHistoricalMetricsTimeout: any;
  ngOnInit(): void {
    this.fromDate.setFullYear(this.fromDate.getFullYear() - 1);
    this.pl = {
      rowOffset: 0,
      rowCount: 10,
      filterOptionRequestColumn: this.filterOptionRequestColumn,
      searchValue: this.searchValue,
      searchField: this.searchField.value,
      filterDict: this.filterDict,
      sortColumn: this.sortColumn,
      sortDescend: this.sortDescend,
      currentUserOnly: false,
      isExport: false,
      filter: {
        FromDate: new Date(this.fromDate).getTime(),
        ToDate: new Date(this.toDate).getTime(),
      },
    };
    this.appService.currentMenu.subscribe((val: boolean) => {
      this.currentMenu = val;
      if(this.currentMenu?.name == 'HistoricalMetrics'){
        this.currentMenu.name = 'Historical'+' '+'Metrics';
      }
      this.action = this.currentMenu.name;
    });

    this.searchField = this.findOptions[0];
    this.initializeColumnHeader();
  }

  applySelectedDateRange(val) {
    this.toDate = val.toDate;
    this.fromDate = val.fromDate;
    this.loadHistoricalMetrics(null);
  }
  resetDateRange() {
    this.toDate = new Date();
    this.fromDate = new Date();
    this.fromDate.setFullYear(this.fromDate.getFullYear() - 1);
    this.loadHistoricalMetrics(null);
  }

  initializeColumnHeader() {
    const localCol = this.webStorage.getItemFromLocalStorage(this.localStorageName);
    if (localCol != null) {
      this.cols = localCol;
    } else {
      for (const col of this.cols) {
        if (col.name == this.sortColumn) {
          if (this.sortDescend) {
            col.isAsc = false;
          } else {
            col.isAsc = true;
          }
        } else {
          delete col.isAsc;
        }
        col.hide = false;
      }
      this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    }
    this.getColumnCount();
  }

  getColumnCount() {
    let shown = 0;
    let hidden = 0;
    for (const header of this.cols) {
      if (header.hide) {
        hidden++;
      } else {
        shown++;
      }
    }
    this.headercount.shown = shown;
    this.headercount.hidden = hidden;
  }

  /*globalFilter*/
  clearSearchBox() {
    this.searchValue = '';
    this.pl['searchField'] = { label: '', value: '' };
    this.loadHistoricalMetrics(null);
  }
  clearFilter() {
    this.cols.forEach((col: any) => {
      delete col.filterVals;
    });
    this.filterDict = '';
    this.loadHistoricalMetrics(null);
  }
  applyFilterByField(val: any) {
    this.searchField = val.searchField;
    this.searchValue = val.searchValue;
    this.loadHistoricalMetrics(null);
  }
  /*column filter* starts here*/
  toggleCustomColumnFilter(colName: string) {
    this.filterOptionRequestColumn = colName;
    this.loadHistoricalMetrics(null);
  }

  showColumnFilterModal(colName: string) {
    const initialState = {
      cols: this.cols,
      colName: colName,
    };
    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };
    this.modalRef = this.modalService.show(FilterDialogComponent, config);
    this.modalRef.content.event.subscribe((result: any) => {
      this.cols = result.data;
      this.applyColumnFilters();
    });
  }

  /*column level filter*/
  applyColumnFilters() {
    this.filterDict = [];
    this.filterOptionRequestColumn = null;
    for (const colData of this.cols) {
      const filterVals: string[] = [];
      if (colData.filterVals && colData.filterVals.length > 0) {
        for (const val of colData.filterVals) {
          if (val.checked) {
            // Handle null values - don't convert to string if null
            const valueToAdd = val.name != null ? val.name.toString() : null;
            filterVals.push(valueToAdd);
          }
        }
        this.filterDict.push({ Key: colData.name, Value: filterVals });
      }
    }
    this.loadHistoricalMetrics(null);
  }
  showHideColumns() {
    const initialState = {
      headerNames: this.cols,
      localStorageName: this.localStorageName,
    };
    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };
    this.modalRef = this.modalService.show(ShowHideDialogComponent, config);
    this.modalRef.content.event.subscribe((result: any) => {
      this.initializeColumnHeader();
    });
  }
  sortByColumn(colName: string) {
    this.sortColumn = colName;
    this.sortDescend = !this.sortDescend;
    //this.cols = this.utils.sortByFieldInServer(colName, this.cols);
    this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    this.loadHistoricalMetrics(null);
  }

  onRowSelect(event: any) {
    this.router.navigateByUrl(this.router.url + '/Details/' + event.data.ID);
  }

  loadHistoricalMetrics(event: TableLazyLoadEvent) {
    this.loading = true;
    if (event == null) {
      this.resetTable();
    } else {
      this.pl.rowOffset = event.first;
      this.pl.rowCount = event.rows;
    }
    this.loadHistoricalMetricsTimeout = setTimeout(
      () => {
        //load data of required page
        if (this.filterOptionRequestColumn != '') {
          this.pl.filterOptionRequestColumn = this.filterOptionRequestColumn;
        } else {
          delete this.pl['filterOptionRequestColumn'];
        }
        this.managerService
          .GetHistoricalMetrics(this.pl)
          .pipe(
            map((data: any) => {
              const isValid = ResponseHandler.processResponse(data, 'GetHistoricalMetrics');
              if (isValid) {
                if (this.pl['filterOptionRequestColumn'] != null) {
                  const columnName = this.pl['filterOptionRequestColumn'];
                  this.pl['filterOptionRequestColumn'] = null;
                  
                  // Get existing checked values for this column before resetting
                  const existingCol = this.cols.find(col => col.name === columnName);
                  const existingCheckedValues = existingCol && existingCol.filterVals ? 
                    existingCol.filterVals.filter(val => val.checked).map(val => val.name) : [];
                  
                  const filterVals = [];
                  for (const dt of data.Response.Data) {
                    // Include null and empty values in the filter options
                    if (dt != null && dt !== '' && dt.trim() !== '') {
                      // Preserve the checked state if this value was previously selected
                      const isChecked = existingCheckedValues.includes(dt);
                      filterVals.push({ name: dt, checked: isChecked });
                    } else {
                      // Add null/empty values as null
                      const isChecked = existingCheckedValues.includes(null);
                      filterVals.push({ name: null, checked: isChecked });
                    }
                  }
                  for (const col of this.cols) {
                    if (col.name == columnName) {
                      col.filterVals = filterVals;
                    }
                  }
                  this.showColumnFilterModal(columnName);
                } else {
                  this.historicalMetricList = data.Response.Data.Data;

                  if (data.Response.Data.TotalFilteredItems) {
                    this.totalRecords = data.Response.Data.TotalFilteredItems;
                  } else {
                    this.totalRecords = 0;
                  }

                  this.loading = false;
                }
                //trigger change detection
                event.forceUpdate();
                this.setInnerWidthHeightParameters();
              } else {
              }
            }),
            catchError(error => {
              this.loading = false;
              return EMPTY;
            })
          )
          .subscribe();
      },
      Math.random() * 1000 + 250
    );
  }
  ngOnDestroy(): void {
    this.loadHistoricalMetricsTimeout && clearTimeout(this.loadHistoricalMetricsTimeout);
  }

  resetTable() {
    this.first = 0;
    //this.historicalMetricList = [];
    //this.totalRecords = 0;

    this.pl['rowOffset'] = this.rowOffset;
    this.pl['rowCount'] = this.rowCount;
    if (this.filterDict != '') {
      this.pl['filterDict'] = this.filterDict;
    } else {
      this.pl['filterDict'] = '';
    }
    this.pl['filterOptionRequestColumn'] = this.filterOptionRequestColumn;
    this.pl['filter'] = {
      FromDate: new Date(this.fromDate).getTime(),
      ToDate: new Date(this.toDate).getTime(),
    };
    this.pl['sortDescend'] = this.sortDescend;
    this.pl['sortColumn'] = this.sortColumn;
    this.pl['searchValue'] = this.searchValue;
    if (this.pl['searchField'].value != '' && this.pl['searchValue'] != '') {
      this.pl['searchField'] = this.searchField.value;
    } else {
      this.pl['searchField'] = '';
    }
  }
  setInnerWidthHeightParameters() {
    this.innerHeight = window.innerHeight * 0.07;
  }
}

